import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'

export async function initMemorizingSetting () {
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('initMemorizingSetting start')
  }

  const Doc = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('Config').doc('memorizingSetting')
  const memorizingSettingDataGet = await Doc.get()
  const memorizingSettingData = memorizingSettingDataGet.data()

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'initMemorizingSetting',
      value: {
        memorizingSettingData
      }
      // , important: true
    })
  }

  if (!memorizingSettingData) {
    await Doc.set({
      skipIds: [],
      thoroughIds: [],
      subsetIds: [],
      subsetBunchNodeIdArrayArray: JSON.stringify([])
    })
  } else {
    globalOnDemandVars.set_skipIds(memorizingSettingData.skipIds)
    globalOnDemandVars.set_thoroughIds(memorizingSettingData.thoroughIds)
    globalOnDemandVars.set_subsetIds(memorizingSettingData.subsetIds)
    globalOnDemandVars.set_subsetBunchNodeIdArrayArray(JSON.parse(memorizingSettingData.subsetBunchNodeIdArrayArray))
  }
}
